export default __webpack_public_path__ + "static/media/cdmx_aerea3.84f2cf74.jpg";